"use strict";exports.__esModule = true;exports.castBool = castBool;

var _is = require("./is");

/**
                            * @namespace __Boolean
                            */

/**
                                * Возвращает первый аргумент если это boolean, иначе второй, если задан, либо - false
                                *
                                * @param {?boolean} maybeBool
                                * @param {boolean} [def]
                                * @returns {boolean}
                                */
function castBool(
maybeBool,
def)
{
  if ((0, _is.isBool)(maybeBool)) return maybeBool;
  if ((0, _is.isBool)(def)) return def;
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/bool.js
// module id = 311
// module chunks = 0